import { LayerType, type ILayerProps } from '@/version-types';
import { getFramework } from '../../view';

export const trackConfig = {
    /** 19 画布  */
    page: {
        /** 弹窗-新增页面 */
        replace: '19_90',
        /** 导航器-新增页面 */
        add: '19_91',
        /** 导航器-拷贝页面 */
        copy: '19_92',
        /** 导航器-删除页面 */
        delete: '19_93',
        /** 导航器-创建单页ppt */
        createSingle: '19_94',
        /** 导航器-重新生成ppt */
        rebuild: '19_95',
    },
    /** 13 画笔 */
    pen: {
        /** 消除笔 */
        eliminate: {
            // 执行消除
            do: '13_60_6',
            // 重置
            reset: '13_60_7',
        },
    },
    /** 10 调整 */
    adjust: {
        /** 裁剪/旋转/尺寸 */
        stage: {
            // 尺寸调整
            resize: '10_40',
            // 比例裁剪
            crop: '10_40_2',
            // 形状蒙版
            mask: '10_40_3',
            // 左旋转、右旋转、水平翻转、垂直翻转
            operate: '10_40_4',
            // 添加自定义尺寸
            size: '10_40_5',
        },
        /** 消除笔 */
        eliminate: {
            // 执行消除
            do: '10_41_6',
            // 重置
            reset: '10_41_7',
        },
        /** 42 光效 */
        light: '10_42',
        /** 43 细节 */
        particulars: '10_43',
        /** 44 色彩 */
        color: '10_44',
        /** 45 色调分离 */
        posterize: '10_45',
        /** 46 HSL */
        hsl: '10_46',
        /** 47 一键换色 */
        intelligentColor: '10_47',
    },
    /** 20 照片 */
    photo: {
        // 插入
        add: '20_96',
        // 裁剪
        crop: '20_63',
        // 滤镜
        filter: '20_999',
        // 蒙版
        mask: '20_64',
        // 一键抠图
        matting: '20_998',
        // 不透明度
        opacity: '20_21',
        // 锁定
        lock: '20_22',
        // 图层顺序
        sort: '20_23',
        // 水平翻转
        flipH: '20_4',
        // 垂直翻转
        flipV: '20_5',
        // 复制
        copy: '20_24',
        // 删除
        delete: '20_25',
        // ai 助手
        aiReplace: '20_97',

        effectClick: '20_55',

        effectStroke: '20_19',

        effectShadow: '20_20',

        effectGlow: '20_98',
    },
    /** 23 ai花字 */
    aiText: {
        // 插入
        add: '23_50',
        // 裁剪
        crop: '23_63',
        // 滤镜
        filter: '23_999',
        // 蒙版
        mask: '23_64',
        // 一键抠图
        matting: '23_998',
        // 不透明度
        opacity: '23_21',
        // 锁定
        lock: '23_22',
        // 图层顺序
        sort: '23_23',
        // 水平翻转
        flipH: '23_4',
        // 垂直翻转
        flipV: '23_5',
        // 复制
        copy: '23_24',
        // 删除
        delete: '23_25',
        // ai 助手
        aiReplace: '23_97',
    },
    /** 11 主图 */
    [LayerType.MAIN_LAYER]: {
        filter: '11_999',
        matting: '10_153',
    },
    /** 13 画笔 svg */
    [LayerType.SVG_LAYER]: {
        add: '13_61',
        // 画笔大小	6
        strokeWidth: '13_61',
        // 画笔强度	28
        opacity: '13_61',
        // 画笔类型	29
        dasharray: '13_61',
        // 圆角	30
        radius: '13_61',
        // 边数	31
        edges: '13_61',
        // 画笔颜色	32
        strokeColor: '13_61',
        // 填充颜色	33
        fillColor: '13_61',
        // 重置	7
        reset: '13_61',
    },
    /** 12 文字 */
    [LayerType.TEXT_LAYER]: {
        // 单图层对齐，水平分布、垂直分布、垂直居中、顶部对齐、水平居中、底部对齐
        align: '12_13',
        // 插入文字
        add: '12_50',
        // 替换字体
        family: '12_51',
        // 字体大小
        size: '12_8',
        // 调整大小
        scale: '12_8',
        // 加粗
        bold: '12_9',
        // 斜体
        italic: '12_10',
        // 下划线	11
        underline: '12_11',
        // 删除线	12
        lineThrough: '12_12',
        // 文字对齐（含左对齐、居中对齐、右对齐、两端对齐、）	13
        textAlign: '12_13',
        // 文字横版、文字竖版	14
        writingMode: '12_14',
        // 字间距	15
        letterSpacing: '12_15',
        // 行间距	16
        lineSpacing: '12_16',
        // 文字特效（点击选中，含高级设置里的操作）	17
        effects: '12_17',
        // 文字纹理
        texture: '12_36',
        // 颜色	18
        color: '12_18',
        // 描边	19
        textStroke: '12_19',
        // 投影	20
        textShadow: '12_20',
        // 背景
        textBackground: '12_99',
        // 外发光
        textGlow: '12_98',
        // 设置文字列表样式
        listStyle: '12_100',
        // 不透明度（调整了值才上报）	21
        opacity: '12_21',
        // 锁定	22
        lock: '12_22',
        // 图层顺序	23
        sort: '12_23',
        // 水平翻转	4
        flipH: '12_4',
        // 垂直翻转	5
        flipV: '12_5',
        // 复制	24
        copy: '12_24',
        // 删除	25
        delete: '12_25',
        // 重写
        aiRewrite: '1_30',
        // 美化
        aiBeautify: '1_31',
        // 拓写
        aiExtensive: '1_32',
        // 精简
        aiSimplify: '1_33',
        // 文字变形
        transformEffect: '12_58',
        // 格式刷复制样式
        copyBrush: '12_111',
        // 划重点
        mark: '12_161',
    },
    /** 14 图片 */
    [LayerType.IMAGE_LAYER]: {
        // 插入素材	62
        add: '14_62',
        // 裁剪	63
        crop: '14_63',
        // 滤镜	999
        filter: '14_999',
        // 蒙版	64
        mask: '14_64',
        // 一键抠图	998
        matting: '14_998',
        // 旋转	66
        rotate: '14_66',
        // 不透明度	21
        opacity: '14_21',
        // 锁定	22
        lock: '14_22',
        // 图层顺序	23
        sort: '14_23',
        // 水平翻转	4
        flipH: '14_4',
        // 垂直翻转	5
        flipV: '14_5',
        // 复制	24
        copy: '14_24',
        // 删除	25
        delete: '14_25',
        // ai 助手
        aiReplace: '2_36',

        effectClick: '14_55',

        effectStroke: '14_19',

        effectShadow: '14_20',

        effectGlow: '14_98',

        aiModifyImage: '27',
        aiExpendImage: '26',
    },
    /** 14 矢量素材 */
    [LayerType.VECTOR_LAYER]: {
        // 插入素材	62
        add: '14_62',
        // 裁剪	63
        crop: '14_63',
        // 蒙版	64
        mask: '14_64',
        // 旋转	66
        rotate: '14_66',
        // 不透明度	21
        opacity: '14_21',
        // 调整颜色
        colors: '14_18',
        // 填充
        fill: '14_104',
        // 描边
        stroke: '14_105',
        // 粗细
        strokeWidth: '14_106',
        // 样式
        strokeDasharray: '14_107',
        // 圆角
        radius: '14_108',
        // 锁定	22
        lock: '14_22',
        // 图层顺序	23
        sort: '14_23',
        // 水平翻转	4
        flipH: '14_4',
        // 垂直翻转	5
        flipV: '14_5',
        // 复制	24
        copy: '14_24',
        // 删除	25
        delete: '14_25',
        //模糊 52
        blur: '14_52',
        //阴影 106
        shadow: '14_106',
        //倒影 51
        reflection: '14_51',
    },
    /** 15 背景 */
    [LayerType.BACKGROUND_LAYER]: {
        // 调整尺寸	68
        resize: '15_68',
        // 裁剪
        crop: '15_25',
        // 恢复原始背景
        reset: '15_66',
        // 列表点击，替换背景	67
        add: '15_67',
        // 替换成渐变色
        gradient: '15_83',
        // 替换成颜色 83
        color: '15_83',
        // 替换背景图	3,
        url: '15_3',
        // 不透明度	21
        opacity: '15_21',
        // 水平翻转	4
        flipH: '15_4',
        // 垂直翻转	5
        flipV: '15_5',
    },
    /** 3 图层组 */
    [LayerType.GROUP_LAYER]: {
        // 成组
        group: '3_26',
        // 解组
        unGroup: '3_27',
        // 多图层对齐
        groupAlign: '3_13',
        // 水平翻转	4
        flipH: '3_4',
        // 垂直翻转	5
        flipV: '3_5',
    },
    /** 21 二维码 */
    [LayerType.QR_CODE]: {
        add: '28_112',
        // 旋转	66
        rotate: '21_66',
        // 不透明度	21
        opacity: '21_21',
        // 背景色
        fill: '21_104',
        // 二维码颜色
        stroke: '21_105',
        /** 网址 */
        text: '28_112',
        /** 公众号 */
        official: '21_102',
        /** 样式 */
        style: '21_100',
        // 锁定	22
        lock: '21_22',
        // 图层顺序	23
        sort: '21_23',
        // 水平翻转	4
        flipH: '21_4',
        // 垂直翻转	5
        flipV: '21_5',
        // 复制	24
        copy: '21_24',
        // 删除	25
        delete: '21_25',
    },
    /** 24 表格 */
    [LayerType.TABLE]: {
        // 通过导入方式添加表格
        addByImport: '28_106',
        // 通过预设添加表格
        add: '28_111',
        // 旋转	66
        rotate: '24_66',
        // 不透明度	21
        opacity: '24_21',
        // 锁定	22
        lock: '24_22',
        // 图层顺序	23
        sort: '24_23',
        // 水平翻转	4
        flipH: '24_4',
        // 垂直翻转	5
        flipV: '24_5',
        // 复制	24
        copy: '24_24',
        // 删除	25
        delete: '24_25',
    },
    /** 28 图表 */
    [LayerType.CHART]: {
        // 通过预设添加图表
        add: '28_176',
        // 旋转	66
        rotate: '28_66',
        // 不透明度	21
        opacity: '28_21',
        // 锁定	22
        lock: '28_22',
        // 图层顺序	23
        sort: '28_23',
        // 水平翻转	4
        flipH: '28_4',
        // 垂直翻转	5
        flipV: '28_5',
        // 复制	24
        copy: '28_24',
        // 删除	25
        delete: '28_25',
    },
    /** 14 矢量素材 */
    [LayerType.BRUSH_LAYER]: {
        add_line: '25_104',
        add_arrow: '25_104',

        add_curve: '25_105',

        add_rect: '25_106',
        add_ellipse: '25_106',
        add_heart: '25_106',
        add_star: '25_106',
        add_triangle: '25_106',
        add_polygon: '25_106',

        // 旋转	66
        rotate: '25_66',
        // 不透明度	21
        opacity: '25_21',

        // 填充
        color: '25_110',
        // 粗细
        width: '25_110',
        // 样式
        style: '25_110',
        // 端点
        point: '25_110',
        // 圆角
        radius: '25_110',

        // 描边
        stroke_color: '25_19',
        // 粗细
        stroke_width: '25_19',
        // 样式
        stroke_style: '25_19',

        // 锁定	22
        lock: '25_22',
        // 图层顺序	23
        sort: '25_23',
        // 水平翻转	4
        flipH: '25_4',
        // 垂直翻转	5
        flipV: '25_5',
        // 复制	24
        copy: '25_24',
        // 删除	25
        delete: '25_25',
    },
    [LayerType.MARKUP_LAYER]: {
        add: '25_160',

        labelType: '25_109',
        labelPosition: '25_109',
        labelRotate: '25_109',
        labelFontFamily: '25_109',
        labelFontSize: '25_109',
        labelColor: '25_109',
        labelStyle: '25_109',
        labelBackground: '25_109',

        fillColor: '25_19',
        fillStyle: '25_19',
        fillWidth: '25_19',
        point: '25_19',
        swap: '25_19',
        line: '25_19',

        // 旋转	66
        rotate: '25_66',
        // 不透明度	21
        opacity: '25_21',
        // 锁定	22
        lock: '25_22',
        // 图层顺序	23
        sort: '25_23',
        // 水平翻转	4
        flipH: '25_4',
        // 垂直翻转	5
        flipV: '25_5',
        // 复制	24
        copy: '25_24',
        // 删除	25
        delete: '25_25',
    },
};

/**
 * 获取功能值
 *
 * @param identity - 标识 ID
 * @param layer - 图层属性
 * @param prop - 属性
 */
export const getTrackFunc = (identity: string, layer: ILayerProps | undefined, prop: string): string => {
    const framework = getFramework(identity);
    const isPhoto = framework.service.flatLayer.checkIsPhoto(layer);
    if (isPhoto) {
        return trackConfig.photo?.[prop] || '';
    }
    const isAiText = framework.service.flatLayer.checkIsAiText(layer);
    if (isAiText) {
        return trackConfig.aiText?.[prop] || '';
    }
    return trackConfig[layer?.layerType || '']?.[prop] || '';
};

/**
 * 获取功能配置
 *
 * @param identity - 标识 ID
 * @param layer - 图层属性
 */
export const getTrackConfig = (identity: string, layer: ILayerProps | undefined) => {
    const framework = getFramework(identity);
    const isPhoto = framework.service.flatLayer.checkIsPhoto(layer);
    if (isPhoto) {
        return trackConfig.photo;
    }
    const isAiText = framework.service.flatLayer.checkIsAiText(layer);
    if (isAiText) {
        return trackConfig.aiText;
    }
    return trackConfig[layer?.layerType || ''];
};
